import { useRef } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { scrollToTop } from "../../utils/scroll";

function SmallContact() {
  const ref = useRef(null);

  useScrollPosition(({ currPos }) => {
    if (!ref.current) return;
    ref.current.classList.toggle("hidden", currPos.y >= -300);
  });

  const handleScrollToTop = (event) => {
    event.preventDefault();
    scrollToTop();
  };

  return (
    <div ref={ref} className="hidden">
      <button
        type="button"
        onClick={handleScrollToTop}
        className="fixed bottom-6 end-5 z-30 sm:bottom-8"
        aria-label="Scroll to top"
      >
        <span className="centered-div relative flex h-9 w-9 items-center justify-center rounded-full bg-[#44444480] text-[20px] text-white">
          <FontAwesomeIcon icon={faArrowUp} aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}

export default SmallContact;
